import { Component } from '@angular/core';
import { AdminManagerService } from '../../../../shared/services/admin-manager.service';
import { SchoolPerformanceDashboardDefinition } from '../../definitions/school-performance-dashboard.definition';
import { ReportDashboardConfigService } from '../../services/report-dashboard-config.service';

@Component({
  selector: 'app-school-performance-dashboard',
  templateUrl: './school-performance-dashboard.component.html'
})
export class SchoolPerformanceDashboardComponent {
  definition = SchoolPerformanceDashboardDefinition;
  expressionContext: any;

  constructor(adminManager: AdminManagerService, configService: ReportDashboardConfigService) {
    this.expressionContext = { pilexosUser: adminManager.getPilexosUser() };
    configService.loadDashboard('school-performance').subscribe(
      definition => this.definition = definition,
      () => this.definition = SchoolPerformanceDashboardDefinition
    );
  }
}
